// extracted by mini-css-extract-plugin
export default {"quillInput":"QuillInput_quillInput__0u8CH","label":"QuillInput_label__okv2R","loaderDiv":"QuillInput_loaderDiv__BSYGC","loader":"QuillInput_loader__LYmSK"};